document.addEventListener('DOMContentLoaded', function() {
  var owl = $('.hero-slider');
  owl.owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true
  });
});

$(document).ready(function() {
  $(".testi-carousel").owlCarousel({
      loop: true,
      margin: 25,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      nav: true,
      navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
      responsive: {
        0: {
          items: 1,
        }
      }
    })

  $('.my-accordion-list > li > .answer').hide();
      
    $('.my-accordion-list > li').click(function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active").find(".answer").slideUp();
      } else {
        $(".my-accordion-list > li.active .answer").slideUp();
        $(".my-accordion-list > li.active").removeClass("active");
        $(this).addClass("active").find(".answer").slideDown();
      }
      return false;
    });
})